import React,{ useEffect, useState }  from 'react';
import logo from './covid19.jpg';
import './App.css';
import axios from "axios";
import {Line} from 'react-chartjs-2';
import {InputGroup, FormControl, Dropdown, DropdownButton, Alert, Card, ListGroupItem, ListGroup} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import NumberFormat from 'react-number-format';
//https://stackoverflow.com/questions/54436233/how-to-get-country-code-and-country-name-using-ip-in-react-js
//https://disease.sh/docs/#/COVID-19%3A%20JHUCSSE/get_v3_covid_19_historical__countries_
//https://www.newline.co/@dmitryrogozhny/quick-introduction-to-displaying-charts-in-react-with-chartjs-and-react-chartjs-2--a85b4e2e
//https://www.chartjs.org/docs/latest/general/responsive.html
function App() {

  
  const[latest,setLatest]=useState([]);
  const[resultsWorld,setResultsWorld]=useState([]);
  const[country,setCountry]=useState("Mexico");
  const[countryInfo,setCountryInfo]=useState([]);
  const[casesWorld,setCasesWorld]=useState({});
  const[confirmed,setConfirmed]=useState([]);
  const[deaths,setDeaths]=useState([]);
  const[recovered,setRecovered]=useState([]);
  const[confirmedWorld,setConfirmedWorld]=useState([]);
  const[deathsWorld,setDeathsWorld]=useState([]);
  const[recoveredWorld,setRecoveredWorld]=useState([]);
  const[error,setError]=useState(false);

  useEffect(()=>{
    if(country===undefined)
      setCountry(country);

    axios
    .all([
      axios.get("https://disease.sh/v3/covid-19/all"),
      axios.get(`https://disease.sh/v3/covid-19/historical/${country}?lastdays=all`),
      axios.get(`https://disease.sh/v3/covid-19/countries/${country}?strict=true`),
      axios.get("https://disease.sh/v3/covid-19/countries?yesterday=false"),
      axios.get("https://disease.sh/v3/covid-19/historical/all?lastdays=all")
    ])
    .then(response=>{
      
      setLatest(response[0].data); //Informacion actual mundial

      setConfirmed(response[1].data.timeline.cases);
      setDeaths(response[1].data.timeline.deaths);
      setRecovered(response[1].data.timeline.recovered);  //World
      setCountryInfo(response[2].data);
      setResultsWorld(response[3].data)
      setCasesWorld(response[4].data);

      setConfirmedWorld(response[4].data.cases);
      setDeathsWorld(response[4].data.deaths);
      setRecoveredWorld(response[4].data.recovered);
      setError(false);
      

    })
    .catch(e=>{
      setError(true);
   
    });
    

    //console.log(country)
},[country]);

//date and time parsing  
const date=new Date(parseInt(latest.updated));
const lastupdated=date.toString();
/** 
const flag=""
if(countryInfo.countryInfo)
{  
  flag=countryInfo.countryInfo.flag;
  ;
}
*/

const Info2=()=>{
  const day=[];
  const confirmedArray=[];
  const deathsArray=[];
  const recoveredArray=[];
  
  
    const objectArray1 = Object.entries(confirmedWorld);
    const objectArray2 = Object.entries(deathsWorld);
    const objectArray3 = Object.entries(recoveredWorld);
    //Confirmed
    objectArray1.forEach(([key, value]) => {
      day.push(key);
      confirmedArray.push(value);
    });
    //Deaths
    objectArray2.forEach(([key, value]) => {
      //day.push(key);
      deathsArray.push(value);
    });
    //Recovered
    objectArray3.forEach(([key, value]) => {
      //day.push(key);
      recoveredArray.push(value);
    });

    const data = {
      labels: day,
      datasets: [
        {
          label: "Confirmed",
          data: confirmedArray,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "rgba(75,192,192,1)"
        },
        {
          label: "Deaths",
          data: deathsArray,
          fill: false,
          borderColor: "#742774"
        },
        {
          label: "Recovered",
          data: recoveredArray,
          fill: false,
          borderColor: "#454575"
        }
      ]
    };

    return data;
  
}

const Info=()=>{
  const day=[];
  const confirmedArray=[];
  const deathsArray=[];
  const recoveredArray=[];

  
    const objectArray1 = Object.entries(confirmed);
    const objectArray2 = Object.entries(deaths);
    const objectArray3 = Object.entries(recovered);
    //Confirmed
    objectArray1.forEach(([key, value]) => {
      day.push(key);
      confirmedArray.push(value);
    });
    //Deaths
    objectArray2.forEach(([key, value]) => {
      //day.push(key);
      deathsArray.push(value);
    });
    //Recovered
    objectArray3.forEach(([key, value]) => {
      //day.push(key);
      recoveredArray.push(value);
    });

    const data = {
      labels: day,
      datasets: [
        {
          label: "Confirmed",
          data: confirmedArray,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "rgba(75,192,192,1)"
        },
        {
          label: "Deaths",
          data: deathsArray,
          fill: false,
          borderColor: "#742774"
        },
        {
          label: "Recovered",
          data: recoveredArray,
          fill: false,
          borderColor: "#454575"
        }
      ]
    };

    return data;
  
}

//For individual chart
const extractInfo=(set)=>{
  const day=[];
  const number=[];
  
  const objectArray = Object.entries(set);
   
  objectArray.forEach(([key, value]) => {
    day.push(key);
    number.push(value);
  });

  const state = {
    labels: day,
    datasets: [
      {
        label: country,
        fill: false,
        lineTension: 0.5,
        backgroundColor: 'rgba(75,192,192,1)',
        borderColor: 'rgba(0,0,0,1)',
        borderWidth: 2,
        data: number
      }
    ]
  }

  return state;
}


  return (
    <div className="Main">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          COVID-19
        </p>
      </header>  
      
      <div className="App-summary">

        <div className="container1">
          <Card>
            <Card.Header>Worldwide</Card.Header>
            <Card.Body>
              <Card.Title>Total cases: <NumberFormat value= {latest.cases} displayType={'text'} thousandSeparator={true} /></Card.Title>
              <Card.Title>Total deaths: <NumberFormat value= {latest.deaths} displayType={'text'} thousandSeparator={true} /></Card.Title>
              <Card.Title>Total recovered: <NumberFormat value= {latest.recovered} displayType={'text'} thousandSeparator={true} /></Card.Title>
              <Card.Subtitle className="mb-2 text-muted">Today cases: <NumberFormat value= {latest.todayCases} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
              <Card.Subtitle className="mb-2 text-muted">Today deaths: <NumberFormat value= {latest.todayDeaths} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
              <Card.Subtitle className="mb-2 text-muted">Today recovered: <NumberFormat value= {latest.todayRecovered} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
            </Card.Body>
          </Card>
        </div>
        <div className="container2">

            <Line 
              data={Info2} 
              options={{
                  title:{
                    display:true,
                    text:'COVID-19 Global Stats',
                    fontSize:25
                  },
                  legend:{
                    display:true,
                    position:'right'
                  }
                }}
            />
  
          </div>  
      </div>    

      <div className="Control">           
       
          <DropdownButton 
            id="dropdown-item-button" 
            title="Select Country"
            onSelect={(e)=>setCountry(e)}
            style={{Color:'black'}}
          >
          
            {
              resultsWorld.map((c,i)=>{
                return <Dropdown.Item key={i} eventKey={c.country}>{c.country}</Dropdown.Item>
              })
            }
          </DropdownButton>
          <h6 style={{color:'black'}}>{lastupdated}</h6> 
   
      </div> 


    {!error ?
    
    
    
 
      <div className="App-summary">

        <div className="container1">
      <Card>
        <Card.Header>{country}</Card.Header>
          <Card.Body>
            {countryInfo.countryInfo!==undefined && <Card.Img variant="top" src={countryInfo.countryInfo.flag} />}
            <Card.Title>Total cases: <NumberFormat value= {countryInfo.cases} displayType={'text'} thousandSeparator={true} /></Card.Title>
            <Card.Title>Total deaths: <NumberFormat value= {countryInfo.deaths} displayType={'text'} thousandSeparator={true} /></Card.Title>
            <Card.Title>Total recovered: <NumberFormat value= {countryInfo.recovered} displayType={'text'} thousandSeparator={true} /></Card.Title>
            <Card.Subtitle className="mb-2 text-muted">Today cases: <NumberFormat value= {countryInfo.todayCases} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
            <Card.Subtitle className="mb-2 text-muted">Today deaths: <NumberFormat value= {countryInfo.todayDeaths} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
            <Card.Subtitle className="mb-2 text-muted">Today recovered: <NumberFormat value= {countryInfo.todayRecovered} displayType={'text'} thousandSeparator={true} /></Card.Subtitle>
          </Card.Body>
        </Card>

        </div>
      <div  className="container2">
  


            <Line 
              data={Info} 
              options={{
                  title:{
                    display:true,
                    text:country,
                    fontSize:25
                  },
                  legend:{
                    display:true,
                    position:'right'
                  }
                }}
            />
  
      </div>


   </div>
:

<Alert variant="danger">
<Alert.Heading>Oh snap! You got an error!</Alert.Heading>
<p>
  This country does not appear in the results.
</p>
</Alert>
}
















           
    </div>
  );
}

export default App;
